module.exports = __webpack_public_path__ + "static/img/LbTu7@2x.36cd902f.png";